/**
 * Marks an English key that is translated later, where it is rendered (labels in config maps,
 * option lists). Returns the key unchanged; tests/shared/i18n-catalog.test.ts checks its translation.
 */
export function msg(key: string): string {
  return key;
}
